import { render, staticRenderFns } from "./contestant-login.vue?vue&type=template&id=a0f123b4&scoped=true"
import script from "./contestant-login.vue?vue&type=script&lang=js"
export * from "./contestant-login.vue?vue&type=script&lang=js"
import style0 from "./contestant-login.vue?vue&type=style&index=0&id=a0f123b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f123b4",
  null
  
)

export default component.exports